import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Paper,
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { connect } from 'react-redux';
import {
  requestTenants,
  showAddTenantModal,
  addTenantUserRequest,
} from '@pingum/app-state-management/tenant/actions';
import {
  email,
  firstName,
  lastName,
} from '@pingum/api-services/UserService/profileKeys';
import NavBar from '../../navigation/NavBar';
import propTypes from '../../../utils/propTypes';
import UserTenantList from './UserTenantsList';
import styles from './styles';

export class TenantSelectionPageComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openRequestToJoinModal: false,
      selectedTenantForRequestToJoin: null,
    };

    this.props.getTenants();
  }

  isSubscribedToTenant = (tenantName) => this.props.profile.subscribedTenants
    .filter((subscribedTenant) => tenantName === subscribedTenant).length === 1

  handleOpenRequestToJoinModal = (tenantName) => {
    this.setState({
      openRequestToJoinModal: true,
      selectedTenantForRequestToJoin: tenantName,
    });
  }

  handleCloseRequestToJoinModal = () => {
    this.setState({
      openRequestToJoinModal: false,
      selectedTenantForRequestToJoin: null,
    });
  }

  handleSendRequestToJoin = () => {
    this.props.addTenantUserRequest(this.state.selectedTenantForRequestToJoin, {
      auth0UserId: this.props.profile.user_id,
      email: this.props.profile[email],
      firstName: this.props.profile[firstName],
      lastName: this.props.profile[lastName],
    });
    this.setState({
      openRequestToJoinModal: false,
      selectedTenantForRequestToJoin: null,
    });
  }

  render() {
    const {
      classes,
      profile,
    } = this.props;
    return (
      <div className={classes.container}>
        <NavBar forceVisible />

        <Avatar src={(profile || {}).picture} className={classes.profileImage} />
        <div className={classes.content}>
          <Paper className={classes.root} elevation={10}>
            <div className={classes.offset}>
              <div className={classes.profileContainer}>
                <h2>Welcome back</h2>
                <h4>
                  To continue, select one of your organizations or create a new one.
                </h4>
              </div>
            </div>
          </Paper>
          <UserTenantList />
        </div>
        <Dialog
          open={this.state.openRequestToJoinModal}
          onClose={this.handleCloseRequestToJoinModal}
          aria-labelledby="request-to-join-dialog"
          aria-describedby="request-to-join-dialog-description"
          id="request-to-join-dialog"
        >
          <DialogTitle id="request-to-join-dialog">Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText id="request-to-joindialog--description">
              Do you want to send this requests to join the Organization?
              An administrator for the Organization will first need to
              accept the request before you gain access.
              You will receice and email if your request is accepted.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => { this.handleCloseRequestToJoinModal(); }}
              id="cancel-join-button"
            >
              Cancel
            </Button>
            <Button
              onClick={() => { this.handleSendRequestToJoin(); }}
              color="primary"
              variant="contained"
              autoFocus
              id="confirm-join-button"
            >
              Send Request
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

TenantSelectionPageComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  profile: PropTypes.shape(propTypes.user).isRequired,
  getTenants: PropTypes.func.isRequired,
  addTenantUserRequest: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => ({
  profile: state.user.user,
  tenants: state.user.tenants,
  isFetching: state.user.isFetchingUser,
});

export const mapDispatchToProps = (dispatch) => ({
  getTenants: () => dispatch(requestTenants()),
  addTenant: () => dispatch(showAddTenantModal()),
  addTenantUserRequest: (tenantName, request) => dispatch(addTenantUserRequest(tenantName, request)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(TenantSelectionPageComponent));
